export interface ImageResource {
    path: string;
}

export interface AvailableImages {
    CompatibilityCheck: ImageResource;
    Logo_CFM: ImageResource;
    Logo_GG: ImageResource;
    Logo_HQV: ImageResource;
    Logo_KTM: ImageResource;
    Logo_MVA: ImageResource;
    Logo_PMAG: ImageResource;
    Logo_WP: ImageResource;
}

const Images: AvailableImages = {
    CompatibilityCheck: { path: "compatibility_check.png" },
    Logo_CFM: { path: "logo_cfm.png" },
    Logo_GG: { path: "logo_gg.png" },
    Logo_HQV: { path: "logo_hqv.png" },
    Logo_KTM: { path: "logo_ktm.png" },
    Logo_MVA: { path: "logo_mva.png" },
    Logo_PMAG: { path: "logo_pmag.png" },
    Logo_WP: { path: "logo_wp.png" },
};

export { Images };
